import { render } from "./windowPortal.vue?vue&type=template&id=7ae818a6"
import script from "./windowPortal.vue?vue&type=script&lang=js"
export * from "./windowPortal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__